(function(){
    'use strict';
    angular.module('Services').factory('LoadingModalFactory', LoadingModalFactory);
    LoadingModalFactory.$inject = ['$uibModal'];

    function LoadingModalFactory($uibModal) {
        let service = this;
        let modalInstance;

        service.open = ()=>{
            modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                backdrop  : 'static',
                keyboard  : false,
                ariaDescribedBy: 'modal-body',
                windowClass: 'r-c-p-modal',
                templateUrl: '/templates/UX/loading-modal.html',
                size: 'sm',
                appendTo: $('body')
            });
        }

        service.close = ()=>{
            modalInstance.close();
        }

        return service;
        
    }
})()


// WEBPACK FOOTER //
// ./js/services/UX/LoadingModalFactory.js